 <template lang="html">
    <div class="row"> 
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Edit Opening Time</h5>
                    <form class="forms-sample">
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="From Time">
                                    <vue-timepicker v-model="openingTime.fromTime"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="To Time">
                                    <vue-timepicker v-model="openingTime.toTime"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Default Waiting Time">
                                    <b-form-select v-model="openingTime.defaultWaitingTime" 
                                                        :options="waitingTimeOptions">
                                    </b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="Rush Hour From">
                                    <vue-timepicker v-model="openingTime.rushHourFrom"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Rush Hour To">
                                    <vue-timepicker v-model="openingTime.rushHourTo"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Rush Hour Waiting Time">
                                    <b-form-select v-model="openingTime.rushHourWaitingTime" 
                                                        :options="waitingTimeOptions">
                                    </b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group label="Can order from">
                                    <vue-timepicker v-model="openingTime.canOrderFrom"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Cannot order from">
                                    <vue-timepicker v-model="openingTime.cannotOrderFrom"
                                                    :minute-interval="5">
                                    </vue-timepicker>
                                </b-form-group>
                            </div>
                            
                        </div>
                        <b-form-group label="Is Opened">
                            <b-form-checkbox v-model="openingTime.isOpened"
                                          >
                            </b-form-checkbox>
                        </b-form-group>
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Save
                        </b-button>
                        <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import VueTimepicker from 'vue2-timepicker'
import TimeFormatter from '../../../src/assets/js/TimeFormatter'
export default{
    name: 'openingtimeeditform',
    components: {
        VueTimepicker
    },
    data () { 
        return {
            openingTime: {
                fromTime: '',
                toTime: '',
                canOrderFrom: '',
                cannotOrderFrom: '',
                defaultWaitingTime: '',
                rushHourFrom: '',
                rushHourTo: '' ,
                rushHourWaitingTime: '',
                isOpened: '' 
            },
            waitingTimeOptions: [
                {value: 5, text: '5 minutes'},
                {value: 10, text: '10 minutes'},
                {value: 15, text: '15 minutes'},
                {value: 20, text: '20 minutes'},
                {value: 25, text: '25 minutes'},
                {value: 30, text: '30 minutes'},
                {value: 35, text: '35 minutes'},
                {value: 40, text: '40 minutes'},
                {value: 45, text: '45 minutes'},
                {value: 50, text: '50 minutes'},
                {value: 55, text: '55 minutes'},
                {value: 60, text: '60 minutes'}
            ]
        }
    },
    methods: {
        async handleBtnSave() {
            await this.$store.dispatch('openingtimes/updateOpeningTimeAction', this.openingTime);
            this.$router.push('/openingtimes');
        },
        handleBtnCancel() {
            this.$router.push('/openingtimes');
        }
    },
    created() {
        this.openingTime = this.$lodash
                                .cloneDeep(this.$store.state.openingtimes.openingtimes
                                                            .find(o => o.label === this.$route.params.id));
                                                            
        this.openingTime.fromTime = TimeFormatter.formatTime(this.openingTime.fromTime);
        this.openingTime.toTime = TimeFormatter.formatTime(this.openingTime.toTime);
        this.openingTime.canOrderFrom = TimeFormatter.formatTime(this.openingTime.canOrderFrom);
        this.openingTime.cannotOrderFrom = TimeFormatter.formatTime(this.openingTime.cannotOrderFrom);
        this.openingTime.rushHourFrom = TimeFormatter.formatTime(this.openingTime.rushHourFrom);
        this.openingTime.rushHourTo = TimeFormatter.formatTime(this.openingTime.rushHourTo);
    }
}
</script>